import { BottomSheetDialog } from '@medely/web-components';
import useDevice from '@mp/hooks/useDevice.web';
import React from 'react';
import { Box, Divider, Text, VStack } from '@medely/ui-kit';

type ExperienceEditModalProps = {
  open: boolean;
  onClose: () => void;
  deleteExperience: (id?: number) => void;
  openEditModal?: () => void;
};

const ModalInfo = ({
  deleteExperience,
  openEditModal,
  onClose,
}: Pick<ExperienceEditModalProps, 'deleteExperience' | 'openEditModal' | 'onClose'>) => {
  return (
    <VStack>
      <Box
        onClick={() => {
          openEditModal?.();
          onClose();
        }}
        py={1.5}
      >
        <Text size="l">Edit</Text>
      </Box>
      <Divider />
      <Box
        onClick={() => {
          deleteExperience();
          onClose();
        }}
        py={1.5}
      >
        <Text size="l">Delete</Text>
      </Box>
    </VStack>
  );
};

export const ExperienceEditModal = ({
  open,
  onClose,
  deleteExperience,
  openEditModal,
}: ExperienceEditModalProps) => {
  const isDesktop = useDevice() === 'desktop';

  return (
    <BottomSheetDialog
      open={open}
      onClose={onClose}
      content={
        <ModalInfo
          deleteExperience={deleteExperience}
          openEditModal={openEditModal}
          onClose={onClose}
        />
      }
      isDesktop={isDesktop}
      fullWidth={isDesktop}
      sx={{ top: isDesktop ? 0 : '80%' }}
    />
  );
};
